<template>
  <b-row class="mt-3">
    <b-col sm="12" md="6" lg="6">
      <div class="join-columns">
        <div class="mt-3 mb-5 align-items-center d-flex justify-content-between"
          v-b-toggle="$root.isMobile && 'client'"
        >
          <h4 class="my-2 text-uppercase">
            i am a
            <span class="yellow">client</span>
          </h4>

          <div class="toggle-icons">
            <svg svg-inline="" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><g fill="none" fill-rule="evenodd" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M22 13l-6 6-6-6"/><path d="M.5.5h31v31H.5z"/></g></svg>
          </div>
        </div>
        <b-collapse id="client" :visible="!$root.isMobile" :accordion="$root.isMobile && 'join'">
          <div class="icon-label mb-3">
            <svg svg-inline="" class="icon white" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="47" height="17" viewBox="0 0 47 17"><path fill="#969696" d="M46.066 13.472c.07 1.865-1.397 3.43-3.3 3.498H16.98a.75.75 0 0 1-.63-.344L9.38 5.808a.75.75 0 0 1 .527-1.15l3.142-.438a.75.75 0 0 1 .638.217l5.784 5.885 5-.021-10.066-8.69a.75.75 0 0 1 .44-1.315l4.301-.294a.75.75 0 0 1 .464.122l15.414 10.148 7.533-.05c1.87-.062 3.441 1.39 3.51 3.25zm-3.478-1.75h-.014l-7.768.052a.75.75 0 0 1-.417-.124L18.996 1.515l-2.23.153 10.202 8.806c.525.453.207 1.315-.487 1.318l-7.32.032a.75.75 0 0 1-.538-.225l-5.74-5.84-1.606.223 6.112 9.488h25.35a1.885 1.885 0 0 0 1.828-1.943 1.89 1.89 0 0 0-1.979-1.805zM11.581 15.47a.75.75 0 1 1 0 1.5H.75a.75.75 0 0 1 0-1.5h10.831zm-3.84-3.829c.414 0 .75.224.75.5s-.336.5-.75.5H.75c-.414 0-.75-.224-.75-.5s.336-.5.75-.5h6.991z"/></svg>
          </div>
          <newsletter />
        </b-collapse>
      </div>
    </b-col>
    <b-col sm="12" md="6" lg="6">
      <div class="join-columns join-right">
        <div class="mt-3 mb-5 align-items-center d-flex justify-content-between"
          v-b-toggle="$root.isMobile && 'tattooer'"
        >
          <h4 class="my-2 text-uppercase">
            i am a
            <span class="yellow">tattooer</span>
          </h4>
          <div class="toggle-icons">
            <svg svg-inline="" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><g fill="none" fill-rule="evenodd" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M22 13l-6 6-6-6"/><path d="M.5.5h31v31H.5z"/></g></svg>
          </div>
        </div>
        <b-collapse id="tattooer" :visible="!$root.isMobile" :accordion="$root.isMobile && 'join'">
          <div class="icon-label mb-3">
            <svg svg-inline="" class="icon white" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="47" height="17" viewBox="0 0 47 17"><path fill="#969696" d="M46.066 13.472c.07 1.865-1.397 3.43-3.3 3.498H16.98a.75.75 0 0 1-.63-.344L9.38 5.808a.75.75 0 0 1 .527-1.15l3.142-.438a.75.75 0 0 1 .638.217l5.784 5.885 5-.021-10.066-8.69a.75.75 0 0 1 .44-1.315l4.301-.294a.75.75 0 0 1 .464.122l15.414 10.148 7.533-.05c1.87-.062 3.441 1.39 3.51 3.25zm-3.478-1.75h-.014l-7.768.052a.75.75 0 0 1-.417-.124L18.996 1.515l-2.23.153 10.202 8.806c.525.453.207 1.315-.487 1.318l-7.32.032a.75.75 0 0 1-.538-.225l-5.74-5.84-1.606.223 6.112 9.488h25.35a1.885 1.885 0 0 0 1.828-1.943 1.89 1.89 0 0 0-1.979-1.805zM11.581 15.47a.75.75 0 1 1 0 1.5H.75a.75.75 0 0 1 0-1.5h10.831zm-3.84-3.829c.414 0 .75.224.75.5s-.336.5-.75.5H.75c-.414 0-.75-.224-.75-.5s.336-.5.75-.5h6.991z"/></svg>
          </div>
          <h2 class="h1 color-white mb-3">
            Plan your
            <span class="yellow">travels</span> where
            <br v-if="$root.isDesktop"/> work is waiting for you!
          </h2>
          <ul class="list mb-3">
            <li>Your Coal page can feature your travel plans, if you have any.</li>
            <li>Your clients can request you to their city.</li>
            <li>You can reach out to them when you plan on going.</li>
            <li>It’s all free.</li>
          </ul>
          <div class="pt-3">
            <b-button
              variant="coal-yellow"
              class="big"
              ref="artistCreatePageClicked"
              href="https://docs.google.com/forms/d/e/1FAIpQLSftcRaV4a047zWbuPe7EwrfEdU1uWcx3nDTrhfqyZqrq_b36g/viewform"
              target="_blank"
            >Set-up your Coal page</b-button>
          </div>
        </b-collapse>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import Newsletter from '../components/Newsletter.vue';

export default {
  name: 'Join',
  mounted() {
  },
  components: {
    Newsletter,
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/css/variables";

.toggle-icons {
  display: initial;

  color: $yellow;
  transform: rotate(180deg);

  .collapsed & {
    color: #505050;
    transform: rotate(0);
  }

  @media screen and (min-width: 991px) {
    display: none;
  }
}

.join-columns {
  @media screen and (min-width: 991px) {
    max-width: 405px;

    &.join-right {
      margin-left: auto;
    }
  }
}


</style>
